// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1407":"9e4d593f","1996":"034c8552","2473":"8c9caec7","2969":"95e185ae","5046":"ca047796","7041":"70dd94cd","8113":"ea578edf"}[chunkId] + ".chunk.css";
};